export interface IDialog extends IDialogPayload {
  type: DialogType;
}

export interface IDialogPayload {
  text: string;
  okText: string;
  cancelText: string;
  title: string;
}

export const enum DialogClick {
  Ok,
  Cancel
}

export const enum DialogType {
  Data,
  None
}

export interface IDialogState extends IDialog {
  open: boolean;
  dlgClick?: DialogClick;
}
